import React from "react";
import Countries from "../components/main/Countries";
import Layout from "../components/layout/Layout";

const Home = () => {
  return (
    <Layout>
      <Countries />
    </Layout>
  );
};

export default Home;